
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.943 8l2.862-2.862a.666.666 0 10-.943-.943L8 7.057 5.138 4.195a.666.666 0 10-.943.943L7.057 8l-2.862 2.862a.666.666 0 10.943.943L8 8.943l2.862 2.862a.665.665 0 00.943 0 .666.666 0 000-.943L8.943 8z"}})])
          )
        }
      }
    